import { Button, Flex, Popconfirm, Row } from 'antd';
import React, { Component } from 'react';
import { ReactComponent as DiceIcon } from '../assets/dice.svg';
import { ReactComponent as PaperIcon } from '../assets/hand-paper.svg';
import { ReactComponent as RockIcon } from '../assets/hand-rock.svg';
import { ReactComponent as ScissorsIcon } from '../assets/hand-scissors.svg';
import { ChoiceTypeEnum, IGameItem } from '../store/game.types';
import { ReactComponent as HeadsIcon } from '../assets/heads.svg';
import { ReactComponent as TailsIcon } from '../assets/tails.svg';
import Text from 'antd/es/typography/Text';
import { AppContext, AppContextValue } from '../../../theme/AppContextProvider';
import dayjs from 'dayjs';
import { SafetyOutlined } from '@ant-design/icons';

type ChoiceIconsMap = Partial<Record<ChoiceTypeEnum, JSX.Element>>;

const choiceIcons: ChoiceIconsMap = {
  [ChoiceTypeEnum.ROCK]: <RockIcon />,
  [ChoiceTypeEnum.SCISSORS]: <ScissorsIcon />,
  [ChoiceTypeEnum.PAPER]: <PaperIcon />,
  [ChoiceTypeEnum.HEADS]: <HeadsIcon />,
  [ChoiceTypeEnum.TAILS]: <TailsIcon />,
  [ChoiceTypeEnum.DICE]: <DiceIcon />,
};

interface IProps {
  game: IGameItem;
  style?: React.CSSProperties;
  clickInfo?: () => void;
}

class _ResultChoice extends Component<IProps> {
  static contextType = AppContext;
  render() {
    const { globalTheme, isMobile } = this.context as AppContextValue;
    const {
      ownerChoice,
      playerChoice,
      playerName,
      colorResult,
      titleResult,
      isMember,
      winnerId,
      winnerName,
      ownerName,
      md5,
      createdAt,
    } = this.props.game;
    const height: number = (this.props.style?.height as number) || 36;

    if (!ownerChoice || !playerChoice) {
      return null;
    }

    const ownerIcon = choiceIcons[ownerChoice] || <DiceIcon />;
    const playerIcon = choiceIcons[playerChoice] || <DiceIcon />;
    const isViewSmallResult = !isMember && winnerId;

    return (
      <Flex align={'center'} justify={'space-between'} style={{ width: '100%' }}>
        {!isMobile && (
          <>
            <Flex vertical>
              <Text style={{ fontWeight: 400, fontSize: 14, marginLeft: 5 }}>{ownerName}</Text>
              <Row>
                <Text
                  style={{
                    fontWeight: 400,
                    fontSize: 24,
                    marginLeft: 5,
                    rotate: '45deg',
                    lineHeight: 1.2,
                    color: globalTheme?.colorBorder,
                  }}
                >
                  {'+'}
                </Text>
                <Text style={{ fontWeight: 400, fontSize: 14, marginLeft: 5 }}>{playerName}</Text>
              </Row>
            </Flex>
            <Flex vertical>
              <Text>{dayjs(createdAt).format('HH:mm')}</Text>
              <Text type={'secondary'} style={{ fontSize: 12, marginTop: -3 }}>
                {dayjs(createdAt).format('DD MMMM')}
              </Text>
            </Flex>
            <Popconfirm title={'Hash для проверки честности игры'} description={md5}>
              <Button
                type={'text'}
                style={{ color: globalTheme?.green5 }}
                icon={<SafetyOutlined width={40} height={40} />}
              />
            </Popconfirm>
          </>
        )}
        <Row
          style={{
            borderRadius: 20,
            padding: 3,
            backgroundColor: colorResult,
          }}
        >
          {[ownerIcon, playerIcon].map((i, index) => (
            <Button
              key={index.toString()}
              disabled
              style={{
                height: height,
                width: 50,
                borderRadius: 20,
                backgroundColor: 'transparent',
                borderWidth: 0,
              }}
              icon={React.cloneElement(i, {
                style: { height, width: height, fill: '#fff' },
              })}
            />
          ))}
        </Row>

        <Flex vertical style={{ width: isMobile ? undefined : '20%' }}>
          <Text style={{ color: colorResult, fontSize: isViewSmallResult ? 12 : 20, fontWeight: 600 }}>
            {titleResult}
          </Text>
          {isViewSmallResult && <Text style={{ fontSize: 12 }}>{winnerName}</Text>}
        </Flex>
        {isMobile && (
          <Button
            style={{
              height: 42,
              width: 20,
              borderRadius: 10,
              borderWidth: 1,
              borderColor: globalTheme?.green5,
              color: globalTheme?.green5,
              fontSize: 28,
              fontWeight: 700,
            }}
            onClick={() => this.props.clickInfo?.()}
          >
            {'i'}
          </Button>
        )}
      </Flex>
    );
  }
}

export const ResultChoice = _ResultChoice;
